import { EAppSettings } from "library/types";
import { useGetUserAppTargetSetting } from "./useGetUserAppTargetSetting";

export function useIsDarkMode() {
  const darkModeAppSetting = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.darkMode,
  });

  const darkMode = darkModeAppSetting?.userAppSettingValue === "true";

  return darkMode;
}
